export default __webpack_public_path__ + "static/media/avatar_161.e5c92f1c.png";